var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3679_5470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4592 12.5147C18.1841 12.5147 17.9611 12.7377 17.9611 13.0128V17.4354C17.9601 18.2604 17.2918 18.929 16.4668 18.9298H2.49052C1.66551 18.929 0.997203 18.2604 0.996207 17.4354V4.45536C0.997203 3.63055 1.66556 2.96205 2.49052 2.96105H6.91318C7.18828 2.96105 7.41128 2.73805 7.41128 2.46295C7.41128 2.18799 7.18828 1.96484 6.91318 1.96484H2.49052C1.11565 1.96639 0.00154412 3.0805 0 4.45536V17.4356C0.00154412 18.8105 1.11565 19.9246 2.49052 19.9262H16.4668C17.8416 19.9246 18.9558 18.8105 18.9573 17.4356V13.0128C18.9573 12.7377 18.7343 12.5147 18.4592 12.5147Z",
    fill: "#1D1E25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7597 0.682893C17.8844 -0.192475 16.4651 -0.192475 15.5898 0.682893L6.70324 9.56941C6.64241 9.63023 6.59837 9.70577 6.57542 9.78867L5.40682 14.0076C5.38324 14.0926 5.38263 14.1822 5.40505 14.2675C5.42748 14.3528 5.47213 14.4305 5.53446 14.4929C5.59679 14.5552 5.67455 14.5999 5.7598 14.6224C5.84505 14.6448 5.93474 14.6442 6.01969 14.6207L10.2386 13.4519C10.3215 13.4289 10.3971 13.3849 10.4579 13.3241L19.3442 4.4374C20.2182 3.56138 20.2182 2.14338 19.3442 1.26742L18.7597 0.682893ZM7.78855 9.89318L15.0615 2.62007L17.4071 4.96564L10.134 12.2387L7.78855 9.89318ZM7.32004 10.8333L9.1939 12.7075L6.60187 13.4256L7.32004 10.8333ZM18.6399 3.73303L18.1116 4.26122L15.7658 1.91545L16.2943 1.38721C16.7806 0.900962 17.569 0.900962 18.0552 1.38721L18.6399 1.97169C19.1253 2.45853 19.1253 3.24638 18.6399 3.73303Z",
    fill: "#1D1E25"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3679_5470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.3028d8510187aa779eacd8edbb38d264.svg";
export { ForwardRef as ReactComponent };